/**
 * Utility methods for the ui-components-prototype project.
 */

let lastID = 0;
export const generateID = function() {
    const id = lastID;
    lastID++;
    return id;
}

/**
 * Returns a random integer between 0 and the maxNumber provided (inclusive).
 */
const randomNumber = function(maxNumber) {
    return Math.round((maxNumber - 1) * Math.random());
};

export const randomElementFromArray = function(array) {
    const i = randomNumber(array.length);
    return array[i];
}

export const randomElementsFromArray = function(array, numElements) {
    let elements = [];
    for (let i = 0; i < numElements; i++) {
        elements.push(randomElementFromArray(array));
    }
    return elements;
}

/**
 * Returns the url for a random Physics topic icon.
 */
export const randomTopicIconUrl = function() {
    return `/assets/topic-icons/topic-icon-${randomNumber(10) + 1}.png`;
};



// WEBPACK FOOTER //
// ./src/core/Utilities.js